import React from 'react';
import SlimHero from '../ui/hero/hero-slim';

export default () => {
  const pageTitle = "Our Projects - Under Construction";
  return <>
    <SlimHero title={pageTitle}/>
    <div className="row">
      <div className="flex-col" style={{paddingBottom: '50%'}}>
      </div>
    </div>
  </>
}
